export class ForbiddenError extends Error {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, ForbiddenError.prototype);
  }
}

export class UnauthenticatedError extends Error {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, UnauthenticatedError.prototype);
  }
}

export function assertIsError(error: unknown): asserts error is Error {
  if (!(error instanceof Error)) {
    throw error;
  }
}
